import React from "react";
import TermsAndConditionsDetails from "../../../condition-details/TermsAndConditionsDetails";
import RightSideSettingsWrapper from "../../rightside-details-settings/RightSideSettingsWrapper";

const TermsAndConditionsSettings = () => {
  return (
    <RightSideSettingsWrapper>
      <TermsAndConditionsDetails uiChangeConditions={"ui-change"} />
    </RightSideSettingsWrapper>
  );
};

export default TermsAndConditionsSettings;
